import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LeftPanel } from '../../Wrappers';
import { setServicenowOptions } from '../../../redux/features/configSlice';
import { RootState } from '../../../redux/store';
import Api from '../../../utils/api';
import Toaster from '../../Toaster/Index';
// import { Select } from '@primer/react';
import { sendAmplitudeEvents, updatePluginList } from '../../../utils/helper';
import { EventNames } from '../../../utils/events';
import {
    Link,
} from '@primer/react';
import { LTButton, LTFormControl, LTLoader, LTText } from '@lambdatestincprivate/lt-components';
import LTTextInput from '@lambdatestincprivate/lt-components/lib/components/LTInputBox';

const docLink = `${process.env.REACT_APP_DOC_URL}/servicenow-integration`;

export default function ServiceNow() {
    const dispatch = useDispatch();
    const sideBarObject: any = useSelector(
        (state: RootState) => state.config.sideBarObject
    );
    const serviceNowOptions = useSelector(
        (state: RootState) => state.config.servicenowOptions
    );
    const [isLoading, setIsLoading] = useState(false);
    const [clientId, setClientId] = useState('');
    const [clientSecret, setClientSecret] = useState('');
    const [hostedURL, setHostedURL] = useState('');
    const [errors, setErrors] = useState({});
    const [reAuthorize, setReAuthorize] = useState(false);

    useEffect(() => {
        if (serviceNowOptions && serviceNowOptions.type === 'success') {
            Install();
        }
    }, [serviceNowOptions]);


    // Logic for sync when the plugin is installed but refresh token expired
    useEffect(() => {
        if (sideBarObject.is_installed && sideBarObject?.token_expired ){
            setReAuthorize(true);
        }

    }, [sideBarObject.is_installed,sideBarObject.token_expired]);


    const Install = async () => {
        setIsLoading(true);
        setErrors({});
        try {
            const res = await Api.installApi.apiInstall(sideBarObject.code,{
                "START_INSTALL":true,
            });
            if (res.message) {
                Toaster.success(res.message);
            }
            await updatePluginList();
            setIsLoading(false);
            dispatch(setServicenowOptions({ servicenowOptions: null }));
        } catch (err: any) {
            setIsLoading(false);
            if (err.response.data.errors) {
                setErrors(err.response.data.errors);
            } else {
                Toaster.error(err.response.data.message);
            }
            dispatch(setServicenowOptions({ servicenowOptions: null }));
        }
    };

    function isServiceNowReachable() {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve(true);
          img.onerror = () => resolve(false);
          img.src = hostedURL.replace(/\/+$/, '') + '/favicon.ico';
        });
    }
      

    const install = async (e: React.ChangeEvent<any>) => {
        e.preventDefault();
        setIsLoading(true);
        setErrors({});
        // Validate the hosted URL first
        const reachable = await isServiceNowReachable();
        if (!reachable){
            Toaster.error('Invalid ServiceNow instance URL.');
            setIsLoading(false);
            return
        }
        sendAmplitudeEvents(EventNames.INT_CLICK_INSTALL, {
            category: sideBarObject.category,
            plugin_name: sideBarObject.name,
        });
        try {
            const res = await Api.installApi.apiInstall(sideBarObject.code,
                {
                    "START_OAUTH":true,
                    "CLIENT_ID":clientId,
                    "CLIENT_SECRET":clientSecret,
                    "HOSTED_URL":hostedURL
                }
            );
            if (res.data.url) {
                window.open(res.data.url,  '_self');
                setIsLoading(false);
                return;
            }
        } catch (err: any) {
            setIsLoading(false);
            if (err.response.data.errors) {
                setErrors(err.response.data.errors);
            } else {
                Toaster.error(err.response.data.message);
            }
        }
    };

    const reAuthorizeInstall = async (e: React.ChangeEvent<any>) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const res = await Api.installApi.apiInstall(sideBarObject.code,
                {
                    "REAUTHORIZE":true,
                }
            );
            if (res.data.url) {
                window.open(res.data.url, '_self');
                setIsLoading(false);
                return;
            }
        } catch (err: any) {
            setIsLoading(false);
            if (err.response.data.errors) {
                setErrors(err.response.data.errors);
            } else {
                Toaster.error(err.response.data.message);
            }
        }
    }


    return (
        <LeftPanel>
            {(serviceNowOptions && serviceNowOptions.type === 'success')? (
            <div className='flex flex-col items-center justify-center h-full space-y-4 mb-4'>
                <LTLoader
                        heading={`Installation in progress ...`}
                        size='large'
                        containerStyles={{ height: 'auto' }}
                    />
            </div>
            ):
            
            (reAuthorize)? (
                <LTButton
                        variant={LTButton.Variant.PRIMARY}
                        disabled={isLoading}
                        onClick={reAuthorizeInstall}
                        className='self-start'
                    >
                        Re-Authorize
                    </LTButton>
            ):
            (
                <form
                    action=''
                    className='flex flex-col space-y-4'
                    id='form1'
                    onSubmit={install}
                >
                    <LTFormControl
                        formStyles={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginTop: '10px',
                        }}
                        label='Client ID'
                        labelStyle={{ fontSize: 12 }}
                    >
                        <LTTextInput
                            type='password'
                            id='client_id'
                            aria-label='Client ID'
                            width={'100%'}
                            contrast
                            placeholder=''
                            onChange={(value :any) => setClientId(value)}
                            value={clientId}
                            inputOnly={true}
                            required
                        />
                        {(errors as any).client_id && (
                            <small className='w-full h-2.5 text-[10px] text-red-600'>
                                {(errors as any).client_id && (errors as any).client_id[0]}
                            </small>
                        )}
                    </LTFormControl>
                    <LTFormControl
                        formStyles={{
                            display: 'flex',
                            flexDirection: 'column',
                            // gap: '8px',
                            marginTop: '10px',
                        }}
                        label='Client Secret'
                        labelStyle={{ fontSize: 12 }}
                    >
                        <LTTextInput
                            type='password'
                            id='client_secret'
                            aria-label='Client Secret'
                            width={'100%'}
                            contrast
                            placeholder=''
                            onChange={(value :any) => setClientSecret(value)}
                            value={clientSecret}
                            inputOnly={true}
                            required
                        />
                        {(errors as any).client_secret && (
                            <small className='w-full h-2.5 text-[10px] text-red-600'>
                                {(errors as any).client_secret && (errors as any).client_secret[0]}
                            </small>
                        )}
                    </LTFormControl>
                    <LTFormControl
                        formStyles={{
                            display: 'flex',
                            flexDirection: 'column',
                            // gap: '8px',
                            marginTop: '10px',
                        }}
                        label='Hosted URL'
                        labelStyle={{ fontSize: 12 }}
                    >
                        <LTTextInput
                            type='url'
                            id='hosted_url'
                            aria-label='Hosted URL'
                            width={'100%'}
                            contrast
                            placeholder='https://your-instance.service-now.com'
                            onChange={(value :any) => setHostedURL(value)}
                            value={hostedURL}
                            inputOnly={true}
                            required
                        />
                        {(errors as any).hostedURL && (
                            <small className='w-full h-2.5 text-[10px] text-red-600'>
                                {(errors as any).hostedURL && (errors as any).hostedURL[0]}
                            </small>
                        )}
                    </LTFormControl>
                    <LTButton
                        variant={LTButton.Variant.PRIMARY}
                        disabled={isLoading}
                        onClick={install}
                        className='self-start'
                    >
                        Install
                    </LTButton>
                </form>
            )}

            <div className='grid inline-block min-[686px]:absolute min-[686px]:bottom-0 max-[685px]:mt-[16px] mb-[16px]'>
                <LTText color={"muted"}
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    lineHeight: "16px",
                    color: '#666666'
                  }}>Know how to integrate ServiceNow</LTText>
                <Link
					className='focus-black'
                    href={docLink}
                    target='_blank'
                    rel='noreferrer'
                >
                    ServiceNow Integration Guide
                </Link>
            </div>
        </LeftPanel>
    );
}
